import AIAgentView from './AIAgent.View';
import useAIAgent from './useAIAgent';

const AIAgent = () => {
  const { messages, loading, onSendMessage, onFeedbackClick, integrations } = useAIAgent();

  return (
    <AIAgentView
      loading={loading}
      messages={messages}
      integrations={integrations}
      onSendMessage={onSendMessage}
      onFeedbackClick={onFeedbackClick}
    />
  );
};

export default AIAgent;
